import React from 'react';
import {Select} from "antd";

class OccupationSelector extends React.Component {

    onchange(value){
        this.setState({
            value :  value
        });
        this.props.onChange(value);
    }
    render() {
        const occupations = this.props.occupations;
        return (
            <Select
                showSearch
                size={this.props.size}
                style={{ width: 200, ...this.props.style }}
                placeholder={this.props.placeholder}
                optionFilterProp="children"
                onChange={(value) => this.onchange(value)}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                value={this.props.value || undefined}
             >
                {occupations.map((occupation, idx) => {
                    return <Select.Option value={occupation.value} key={occupation.code}>{occupation.value}</Select.Option>
                })}
            </Select>
        )
    }

}

export default OccupationSelector;
